import { API } from "aws-amplify";

export default class HttpRequest {
  static async fetchActivation(params: object) {
    try {
      const response = API.post("activations", "/activations", {
        body: params
      });
      return response;
    } catch (error) {
      return error;
    }
  }

  static async checkout(params: object) {
    try {
      const response = API.post("whitelabel", "/buy", {
        body: params
      });
      return response;
    } catch (error: any) {
      console.error("******", error.response.data.error, "----");
    }
  }

  static async generateBookchainAddress(params: object) {
    try {
      const response = API.post("whitelabel", "/keystore", {
        body: params
      });
      return response;
    } catch (error: any) {
      console.error("******", error.response.data.error, "----");
    }
  }
}
